module.exports = __webpack_public_path__ + "static/section-1.3b485650.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/section-1.png
// module id = ./src/assets/section-1.png
// module chunks = 72334677858794